import { Injectable } from '@angular/core';
import { IHttpService } from '../../common/IHttpService';
import { G_ColoursViewModel } from 'src/app/viewmodels/g-settings/G_ColoursViewModel';
import { EndpointConfig } from '../../common/EndpointConfig';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ColoursService implements IHttpService<G_ColoursViewModel> {
  private _ep: EndpointConfig;
  constructor(private _client: HttpClient) {
    this._ep = new EndpointConfig('GSettings');
  }

  GetList() {
    return this._client.get(this._ep.getEndpointMethod('GetG_ColourList'));
  }

  checkDublication(code) {
    return this._client.post(this._ep.getEndpointMethod('CheckColourDublication'), { Code: code });
  }

  GetById(id: any) {
    return this._client.post(this._ep.getEndpointMethod('GetG_ColourById'), { Id: id });
  }
  Post(obj: G_ColoursViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_Colour'), obj);
  }

  Put(obj: G_ColoursViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_Colour'), obj);
  }

  Delete(obj: G_ColoursViewModel) {
    return this._client.post(this._ep.getEndpointMethod('DeleteG_Colour'), obj);
  }
}
